// extracted by mini-css-extract-plugin
export default {"PriceOfAmounts__wrapper":"NPO9sC3Fr8jnAmeUD9SN","PriceOfAmounts__input":"pQytdYeF_KCxry2ZkGaC"};